import { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const NavigationHandler = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const navigationInProgress = useRef(false);

  const pendingNavigation = useSelector((state: any) =>
    state.getIn(['navigation', 'pendingNavigation'])
  );

  useEffect(() => {
    if (pendingNavigation && !navigationInProgress.current) {
      navigationInProgress.current = true;

      const navData = pendingNavigation.toJS
        ? pendingNavigation.toJS()
        : pendingNavigation;
      const { path, options } = navData;

      if (path) {
        navigate(path, options);
      }

      dispatch({ type: 'NAVIGATION_COMPLETE' });
    }
  }, [pendingNavigation, navigate, dispatch]);

  return null;
};

export default NavigationHandler;
